import React from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// material ui
import {
  Card,
  CardHeader,
  IconButton,
  Grid,
  Box,
  CardContent,
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton,CommonCurdPopUp } from "../../../../components";
import Notifier from "../../../../components/common/Notifier";
import ErrorNotifier from "../../../../components/common/ErrorNotifier";
// redux
import {
  createIndividualResponseStatus,
  getIndividualResponseStatus,
  resetMessage,
  resetErrMessage,
} from "../../../../features/config/individualResponseStatusSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  status: Yup.string().required("Status is required"),
  colorCode: Yup.string().required("Color Code is required"),
  comments: Yup.string(),
});

//   ------------------------------------------------------------------------------------------

const AddIndividualResponseStatus = (props) => {
  const {  message, errMessage,loading } = useSelector((state) => ({
    ...state.individualResponseStatus,
  }));

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      status: "",
      colorCode: "",
      comments: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const res = await dispatch(
        createIndividualResponseStatus({
          responseStatus: values.status,
          colorCode: values.colorCode,
          comments: values.comments,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getIndividualResponseStatus());
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

    const handleSubmit = async () => {
    const result = await formik.submitForm();
    return result;
  };
  return (
    <>

{props?.showAdd && <CommonCurdPopUp
        heading={`Create Invidual Response Status`}
        mediumScreen={true}
        close={props.close}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid spacing={1} container item xs={12} sm={12} md={11} >
            <Grid item xs={12} sm={12} md={8}>
                <MyTextInput
                label="Status"
                type="text"
                name="status"
                required={true}
                fullWidth={true}
                margin="normal"
                id="status"
                value={formik.values.status}
                onChange={formik.handleChange}
                error={
                  formik.touched.status &&
                  Boolean(formik.errors.status)
                }
                helperText={
                  formik.touched.status &&
                  formik.errors.status
                }
              />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                <MyTextInput
                label="Color Code"
                type="color"
                name="colorCode"
                required={true}
                fullWidth={true}
                margin="normal"
                id="colorCode"
                value={formik.values.colorCode}
                onChange={formik.handleChange}
                error={
                  formik.touched.colorCode &&
                  Boolean(formik.errors.colorCode)
                }
                helperText={
                  formik.touched.colorCode &&
                  formik.errors.colorCode
                }
              />
                </Grid>
           
              
                <Grid item xs={12} sm={12} md={12}>
              <MyTextInput
                label="Comments"
                type="text"
                name="comments"
                fullWidth={true}
                margin="normal"
                id="comments"
                value={formik.values.comments}
                onChange={formik.handleChange}
                error={
                  formik.touched.comments && Boolean(formik.errors.comments)
                }
                helperText={formik.touched.comments && formik.errors.comments}
              />
              </Grid>
</Grid>
</Grid>

</CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}
   
    </>
  );
};

export default AddIndividualResponseStatus;
